<template>
  <div class="mbo-scene mbo-game">
    <template v-if="admin">
      <div class="mbo-abs mbo-service mbo-game__camera" :style="box(6, 6, 324, 327)">Окно камеры</div>
    </template>

    <img class="mbo-frame" :src="frame" alt="" :style="frameClip">

    <template v-for="side in sides">
      <div :key="'logo-' + side.camp"
           :class="['mbo-abs', 'mbo-game__logo', 'is-camp' + side.camp]"
           :style="box(side.logoX, 13, 102, 105)">
        <img v-if="side.logo" :src="side.logo" alt="">
        <span v-else>{{ side.short }}</span>
      </div>

      <div v-for="slot in side.stats"
           :key="side.camp + '-' + slot.key"
           class="mbo-abs mbo-game__num"
           :style="box(slot.x, 8, slot.w, 44)">{{ slot.value }}</div>

      <div :key="'kills-' + side.camp"
           class="mbo-abs mbo-game__num mbo-game__kills"
           :style="box(side.killsX, 6, 62, 48)">{{ side.kills }}</div>

      <div :key="'name-' + side.camp" class="mbo-abs mbo-game__name" :style="box(side.nameX, 66, 250, 58)">
        <MbFitText :text="side.name" :max="40" :min="18"/>
      </div>

      <template v-for="(row, i) in side.rows">
        <div v-if="row.hero"
             :key="'hero-' + side.camp + '-' + i"
             class="mbo-abs mbo-game__hero"
             :style="box(side.heroX, ROWS_Y[i] + 1, 78, 82)">
          <MbOverlayHero :hero="row.hero"/>
        </div>
        <div v-if="row.spell && (row.spell.known || admin)"
             :key="'spell-' + side.camp + '-' + i"
             class="mbo-abs mbo-game__spell"
             :style="box(side.spellX, ROWS_Y[i] + 23, 38, 38)">
          <MbOverlayIcon :entry="row.spell" :admin="admin"/>
        </div>
      </template>

      <div v-for="(row, i) in side.rows"
           :key="'row-' + side.camp + '-' + i"
           :class="['mbo-abs', 'mbo-game__row', {'is-right': side.camp === 2}]"
           :style="box(side.rowX, ROWS_Y[i], 126, 84)">
        <MbFitText :text="row.nick" :max="22" :min="12"/>
        <span class="mbo-game__kda">
          {{ row.kda }}
          <em v-if="row.dead" class="mbo-game__dead">{{ row.revive }}</em>
        </span>
        <small>{{ row.gold }}</small>
      </div>
    </template>

    <div class="mbo-abs mbo-game__num mbo-game__timer" :style="box(905, 2, 98, 56)">
      <MbGameTimer :battle="battle"/>
    </div>

    <div v-if="title" class="mbo-abs mbo-game__title" :style="box(848, 66, 220, 58)">
      <MbFitText :text="title" :max="30" :min="14"/>
    </div>

    <template v-if="casterSlots.length">
      <div v-for="(name, i) in casterSlots"
           :key="'caster-' + i"
           class="mbo-abs mbo-game__caster"
           :style="box(1745, 154 + i * 38, 160, 28)">
        <MbFitText :text="name" :max="21" :min="11"/>
      </div>
    </template>

    <div class="mbo-game__feed">
      <span v-for="e in feed" :key="e.id" class="mbo-game__feed-item">
        <i :class="'is-camp' + (e.camp || 0)"></i>{{ e.text }}
      </span>
    </div>

    <div v-if="battle.paused" class="mbo-flash" style="top: 150px">Пауза</div>
    <div v-if="admin && stale" class="mbo-flash mbo-flash--danger mbo-service" style="top: 1030px">Данные задерживаются</div>
  </div>
</template>

<script>
import frame from '@/assets/images/mlbb-broadcast/ingame-frame.png'
import MbFitText from '@/components/MlbbBroadcast/overlay/MbFitText.vue'
import MbGameTimer from '@/components/MlbbBroadcast/overlay/MbGameTimer.vue'
import MbOverlayHero from '@/components/MlbbBroadcast/overlay/MbOverlayHero.vue'
import MbOverlayIcon from '@/components/MlbbBroadcast/overlay/MbOverlayIcon.vue'
import {
  campByNumber,
  campLogoUrl,
  campPlayers,
  campShortName,
  campTeamName,
  describeEvent,
  formatNumber,
  isStale,
  playerHero,
  playerName,
  playerSpell,
} from '@/common/mlbbBroadcast'
import {formatGold, killfeed} from '@/common/mlbbOverlay'
import {box} from '@/components/MlbbBroadcast/overlay/box'

// Координаты сняты с макета «Ингейм без фона.png» (1920×1080). heroX — прозрачная полоса у края
// экрана под портрет героя, spellX — переход от неё к плашке игрока
const ROWS_Y = [350, 437, 527, 617, 706]
const LAYOUT = {
  1: {
    logoX: 352,
    killsX: 843,
    nameX: 472,
    rowX: 133,
    heroX: 2,
    spellX: 88,
    stats: [['kill_tortoise', 516, 62], ['kill_lord', 609, 60], ['total_money', 705, 65], ['kill_tower', 789, 52]],
  },
  2: {
    logoX: 1459,
    killsX: 1003,
    nameX: 1193,
    rowX: 1661,
    heroX: 1840,
    spellX: 1794,
    stats: [['kill_tower', 1068, 47], ['total_money', 1134, 65], ['kill_lord', 1235, 60], ['kill_tortoise', 1326, 62]],
  },
}
// В макете вшиты имена-заглушки комментаторов: без комментаторов вырезаем этот блок из рамки
const CASTERS_HOLE = 'M1690 144H1918V258H1690Z'

export default {
  name: 'MbSceneGame',
  components: {MbFitText, MbGameTimer, MbOverlayHero, MbOverlayIcon},
  props: {
    battle: {type: Object, required: true},
    events: {type: Array, default: () => []},
    casters: {type: Array, default: () => []},
    title: {type: String, default: ''},
    admin: {type: Boolean, default: false},
    now: {type: Number, default: () => Date.now()},
  },
  data() {
    return {frame, ROWS_Y}
  },
  computed: {
    sides() {
      return [1, 2].map((n) => {
        const camp = campByNumber(this.battle, n) || {camp: n}
        const layout = LAYOUT[n]
        return {
          camp: n,
          ...layout,
          name: campTeamName(camp),
          short: campShortName(camp).slice(0, 2),
          logo: campLogoUrl(camp),
          kills: formatNumber(camp.score || 0),
          stats: layout.stats.map(([key, x, w]) => ({
            key,
            x,
            w,
            value: key === 'total_money' ? formatGold(camp[key]) : formatNumber(camp[key] || 0),
          })),
          rows: campPlayers(this.battle, n).map((p) => ({
            nick: playerName(p).name,
            hero: playerHero(p),
            spell: playerSpell(p),
            kda: `${p.kills || 0} / ${p.deaths || 0} / ${p.assists || 0}`,
            gold: formatGold(p.gold),
            dead: !!p.is_dead,
            revive: p.revive_left_time || 0,
          })),
        }
      })
    },
    // в рамке два слота: при одном комментаторе второй закрываем пустой плашкой
    casterSlots() {
      const names = this.casters.map((c) => String(c || '').trim()).filter(Boolean).slice(0, 2)
      return names.length ? [names[0], names[1] || ''] : []
    },
    frameClip() {
      if (this.casterSlots.length) return null
      return {clipPath: `path(evenodd, 'M0 0H1920V1080H0Z ${CASTERS_HOLE}')`}
    },
    feed() {
      return killfeed(this.events, this.battle).map((e) => ({...describeEvent(e, this.battle), id: e.id}))
    },
    stale() {
      return isStale(this.battle, this.now)
    },
  },
  methods: {box},
}
</script>
